/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membersrequests1Inputs */

const en_membersrequests1 = /** @type {(inputs: Membersrequests1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requests`)
};

const de_membersrequests1 = /** @type {(inputs: Membersrequests1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anfragen`)
};

/**
* | output |
* | --- |
* | "Requests" |
*
* @param {Membersrequests1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const membersrequests1 = /** @type {((inputs?: Membersrequests1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membersrequests1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_membersrequests1(inputs)
	return de_membersrequests1(inputs)
});
export { membersrequests1 as "membersRequests" }